module.exports = __webpack_public_path__ + "img/acloud.ca5804e1.png";